import React from "react";
import { buses } from "./data/buses";
import VehicleFullCard from "./VehicleFullCard";

export default function Buses() {
  return (

<>


<section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Buses </h1>
          </div>
        </div>
      </section>

    {/* <div className="vehicle-page">

      <div className="grid">
        {buses.map((v) => (
          <VehicleCard key={v.id} v={v} />
        ))}
      </div>
    </div> */}
<div className="vehicle-page">
  <div className="vehicle-container">
    {buses.map((v) => (
      <VehicleFullCard key={v.id} v={v} />
    ))}
  </div>
</div>

</>
  );
}
